"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _CActions = _interopRequireDefault(require("../materials/CActions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TITLEBAR_PADDING_LEFT = 24;
const TITLEBAR_MIN_HEIGHT = 32;
const TitleBar = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    paddingLeft: TITLEBAR_PADDING_LEFT,
    background: theme.palette.cardHeader.main,
    minHeight: TITLEBAR_MIN_HEIGHT,
    display: 'flex',
    position: 'relative',
    alignItems: 'center'
  };
});

/**
 * タイトルペーパー部品
 * @prop {string, object} [title] - タイトル
 * @prop {node} [children] - 子要素
 * @prop {array} [actions] - アクション要素の配列
 * @prop {bool} [fixedWidth] - 横幅を固定するときに指定する
 */
const TitlePaper = props => {
  const {
    title,
    children,
    actions,
    className,
    fixedWidth
  } = props;
  const actionComponents = actions ? /*#__PURE__*/_react.default.createElement(_CActions.default, {
    actions: actions
  }) : null;
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(TitleBar, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    component: "div",
    color: "text.secondary"
  }, title)), fixedWidth ? /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12,
      md: 10,
      lg: 8
    }
  }, children && children, actionComponents)) : /*#__PURE__*/_react.default.createElement("div", null, children && children, actionComponents));
};
TitlePaper.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  children: _propTypes.default.node,
  actions: _propTypes.default.array,
  fixedWidth: _propTypes.default.bool
};
var _default = exports.default = TitlePaper;